"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  userInfo: function userInfo(state) {
    return state.user.userInfo;
  },
  userId: function userId(state) {
    return state.user.userId;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  sidebarRouters: function sidebarRouters(state) {
    return state.permission.sidebarRouters;
  },
  roleId: function roleId(state) {
    return state.user.roleId;
  },
  noImg: function noImg(state) {
    return state.settings.noImg;
  },
  noData: function noData(state) {
    return state.settings.noData;
  },
  provinceId: function provinceId(state) {
    return state.settings.provinceId;
  },
  wIndustryType: function wIndustryType(state) {
    return state.settings.wIndustryType;
  },
  //产业分类
  wIndustryCategory: function wIndustryCategory(state) {
    return state.settings.wIndustryCategory;
  },
  //行业门类
  wJob: function wJob(state) {
    return state.settings.wJob;
  },
  //职业门类
  wProjectLevel: function wProjectLevel(state) {
    return state.settings.wProjectLevel;
  },
  //项目级别
  wResourceType: function wResourceType(state) {
    return state.settings.wResourceType;
  },
  //资源库类型
  wProfessionalResourceLibraryType: function wProfessionalResourceLibraryType(state) {
    return state.settings.wProfessionalResourceLibraryType;
  },
  //资源库分类
  wCourseLevel: function wCourseLevel(state) {
    return state.settings.wCourseLevel;
  },
  //层次管理
  wYearListAll: function wYearListAll(state) {
    return state.settings.wYearListAll;
  },
  //年份管理
  wApplicationType: function wApplicationType(state) {
    return state.settings.wApplicationType;
  },
  //应用类型
  wMediaType: function wMediaType(state) {
    return state.settings.wMediaType;
  },
  //媒体类型
  wCourseSource: function wCourseSource(state) {
    return state.settings.wCourseSource;
  },
  //课程来源
  wMajorListAll: function wMajorListAll(state) {
    return state.settings.wMajorListAll;
  },
  //专业大类
  wDigitalCourse: function wDigitalCourse(state) {
    return state.settings.wDigitalCourse;
  },
  //数字课程项目
  wVideoClassification: function wVideoClassification(state) {
    return state.settings.wVideoClassification;
  },
  //视频分类管理
  wContestType: function wContestType(state) {
    return state.settings.wContestType;
  },
  //获取比赛类型
  wContestName: function wContestName(state) {
    return state.settings.wContestName;
  },
  //获取比赛名称
  wTitle: function wTitle(state) {
    return state.settings.wTitle;
  },
  wShoolInfo: function wShoolInfo(state) {
    return state.settings.wShoolInfo;
  },
  //院校版学校信息
  wCode: function wCode(state) {
    return state.settings.wCode;
  }
};
var _default = exports.default = getters;